import { API } from '@/api';
import { axiosInstance } from '@/utils/fetcher';
import type { AxiosResponse } from 'axios';

export const getPreClaimsTypesAPI = () => {
  return axiosInstance.request({
    url: `${API.PRECLAIM}/GetClaimType`,
    method: 'get',
  });
};

export type PreClaimsTypesResponse = {
  claimTypeKey: number;
  claimTypeDesc: string;
}[];

export const fetchPreClaimsTypes = async (): Promise<PreClaimsTypesResponse> => {
  const response: AxiosResponse<PreClaimsTypesResponse> = await getPreClaimsTypesAPI();
  return response.data;
};
